"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../ProgressIndicators/index.js");
const index_js_2 = require("../utils/index.js");
require("@itwin/itwinui-css/css/checkbox.css");
/**
 * Simple input checkbox
 * @example
 * <Checkbox />
 * <Checkbox label='Basic Checkbox' />
 * <Checkbox label='Disabled Checkbox' disabled />
 * <Checkbox label='Checked' checked />
 * <Checkbox label='Positive Checkbox' status='positive' />
 * <Checkbox label='Warning Checkbox' status='warning' />
 * <Checkbox label='Negative Checkbox' status='negative' />
 * <Checkbox label='Visibility Checkbox' variant='eyeball' />
 */
exports.Checkbox = React.forwardRef((props, ref) => {
    const { className, disabled = false, indeterminate = false, label, status, variant = 'default', setFocus, isLoading = false, style, ...rest } = props;
    (0, index_js_2.useTheme)();
    const inputElementRef = React.useRef(null);
    const refs = (0, index_js_2.useMergedRefs)(inputElementRef, ref);
    React.useEffect(() => {
        if (inputElementRef.current && setFocus) {
            inputElementRef.current.focus();
        }
    }, [setFocus]);
    React.useEffect(() => {
        if (inputElementRef.current) {
            inputElementRef.current.indeterminate = indeterminate;
            inputElementRef.current.checked = indeterminate
                ? false
                : inputElementRef.current.checked;
        }
    });
    const checkbox = (React.createElement(React.Fragment, null,
        React.createElement("input", { className: (0, classnames_1.default)('iui-checkbox', {
                'iui-checkbox-visibility': variant === 'eyeball',
                'iui-loading': isLoading,
            }, className && { [className]: !label }), style: !label ? style : undefined, disabled: disabled || isLoading, type: 'checkbox', ref: refs, ...rest }),
        isLoading && React.createElement(index_js_1.ProgressRadial, { size: 'x-small', indeterminate: true })));
    return !label ? (checkbox) : (React.createElement("label", { className: (0, classnames_1.default)('iui-checkbox-wrapper', {
            'iui-disabled': disabled,
            [`iui-${status}`]: !!status,
            'iui-loading': isLoading,
        }, className), style: style },
        checkbox,
        label && React.createElement("span", { className: 'iui-checkbox-label' }, label)));
});
exports.default = exports.Checkbox;
